import {Component, forwardRef, Input} from '@angular/core';
import {FormControl, ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'app-form-input-area',
  templateUrl: './form-input-area.component.html',
  styleUrls: ['./form-input-area.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormInputAreaComponent),
      multi: true
    }
  ]
})
export class FormInputAreaComponent implements ControlValueAccessor {
  @Input() field: string;
  @Input() formControl: FormControl;
  @Input() height: string;
  @Input() label: string;

  public onChange = (_: any) => {
  }
  public onTouch = () => {
  }

  constructor() {
  }

  // function to replace new line tags in form control value
  public formatValue(value: string): string {
    return value.replace(/<br>/g, '\n');
  }

  // function to catch input changes and update form in parent
  public onInput($event: any): void {
    this.onTouch();
    this.onChange($event?.target['value']);
  }

  // value accessor functions
  writeValue(value: any): void {
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
}
